export default "__VITE_ASSET__VWlYvufH__"